/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React, { useEffect } from 'react';
import HomeHero from '../containers/Home/HomeHero';
import LatestRelease from '../containers/Home/LatestRelease';
import ArtistsGlance from '../containers/Home/ArtistsGlance';
import ShopGlance from '../containers/Home/ShopGlance';
import FeaturedVideo from '../containers/Home/FeaturedVideo';
import Newsletter from '../containers/Home/Newsletter';
import HomeFooter from '../containers/Home/HomeFooter';

function Home() {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = '';
    return () => { document.body.style.overflow = prev; };
  }, []);

  return (
    <main className="mt-home">
      <HomeHero />
      <LatestRelease />
      <ArtistsGlance />
      <ShopGlance />
      <FeaturedVideo />
      <Newsletter />
      <HomeFooter />
    </main>
  );
}

export default Home;
